// (function mainThemeScript($, Drupal) {
//   Drupal.behaviors.plStarter = {
//     attach(context) {
//       $('html', context).addClass('js');
//     },
//   };
// }(jQuery, Drupal));
jQuery(function ($) {
    $(document).foundation();

    // open external links in new window
    jQuery('a').each(function() {
        var a = new RegExp('/' + window.location.host + '/');
        if(!a.test(this.href)) {
            $(this).click(function(event) {
                event.preventDefault();
                event.stopPropagation();
                window.open(this.href, '_blank');
            });
        }
    });

    // $("select").chosen({
    //     no_results_text: "Oops, no select found(chosen)!",
    //     disable_search: true
    // });

    // console.log( "ready!" );

});
// window.onunload = function() { debugger; }